"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeItemCapabilities = void 0;
var ChangeItemCapabilities;
(function (ChangeItemCapabilities) {
    ChangeItemCapabilities["CanForward"] = "can_forward";
    ChangeItemCapabilities["CanSubmitReviewResponse"] = "can_submit_review_response";
    ChangeItemCapabilities["CanSend"] = "can_send";
    ChangeItemCapabilities["CanEdit"] = "can_edit";
    ChangeItemCapabilities["CanClose"] = "can_close";
    ChangeItemCapabilities["CanDelete"] = "can_delete";
    ChangeItemCapabilities["CanViewHistory"] = "can_view_history";
    ChangeItemCapabilities["CanReopen"] = "can_reopen";
    ChangeItemCapabilities["CanRequestProposal"] = "can_request_proposal";
    ChangeItemCapabilities["CanRequestProposalUpdate"] = "can_request_proposal_update";
    ChangeItemCapabilities["CanSubmitProposal"] = "can_submit_proposal";
    ChangeItemCapabilities["CanRequestSignature"] = "can_request_signature";
    ChangeItemCapabilities["CanSubmitSignature"] = "can_submit_signature";
    ChangeItemCapabilities["CanSendSignedProposal"] = "can_send_signed_proposal";
    ChangeItemCapabilities["CanCancelRequestSignature"] = "can_cancel_request_signature";
    ChangeItemCapabilities["CanReceive"] = "can_receive";
})(ChangeItemCapabilities = exports.ChangeItemCapabilities || (exports.ChangeItemCapabilities = {}));
//# sourceMappingURL=ChangeItemCapabilities.js.map